





/* eslint-disable no-sequences */
/* eslint-disable no-unused-vars */
/* eslint-disable no-param-reassign */
/* eslint-disable no-unused-expressions */

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { defaultReject, defaultState } from "../../../constants";
import { fetchData } from "../../../helpers";
// customerRegister
// CUSTOMERREGISTER
const GETPURCHASEBYID= createAsyncThunk(
  "getPurchaseById/getPurchaseById",
  // eslint-disable-next-line default-param-last
  async (
    // eslint-disable-next-line default-param-last
    payload = {},
    { rejectWithValue }
  ) => {
    try {
      const data = await fetchData(
        payload?.data,
        payload?.method,
        payload?.apiName
      );
      return {
        ...defaultState.List,
        message: data?.data.Message,
        data: data?.data?.data,
      };
    } catch (error) {
      return rejectWithValue({
        ...defaultReject.List,
        message: error.message,
      });
    }
  }
);

// PublishPostSlice
const getPurchaseByIdSlice = createSlice({
  name: "getPurchaseByIdSlice",
  initialState: {
    getPurchaseById: {
      ...defaultState.List,
      loading: false, 
      error: false, 
    },
  },
  reducers: {
    setInitialStateOfgetPurchaseById: (state) => {
        state.getPurchaseById.loading = false
        state.getPurchaseById.error = false
        state.getPurchaseById.data = []
        state.getPurchaseById.message = ''
      }
  },
  extraReducers: (builder) => {
    builder.addCase(GETPURCHASEBYID.fulfilled, (state, action) => {
      state.getPurchaseById = {
        ...state.getPurchaseById,
        loading: false,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(GETPURCHASEBYID.pending, (state, action) => {
      state.getPurchaseById = {
        ...state.getPurchaseById,
        loading: true,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(GETPURCHASEBYID.rejected, (state, action) => {
      state.getPurchaseById = {
        ...state.getPurchaseById,
        loading: false,
        error: true,
        ...action.payload,
      };
    });
  },
});

const getPurchaseByIdAction = {
    GETPURCHASEBYID,
};

export { getPurchaseByIdAction };
export default getPurchaseByIdSlice.reducer;
export const {setInitialStateOfgetPurchaseById} = getPurchaseByIdSlice.actions
